import React from "react";

import SectionHeroGeneric from '@brz-components/sections/hero/section.hero.generic';
import SectionHeroProposal from "@brz-components/sections/hero/section.hero.proposal";


const SectionHeroAgent = React.lazy(() => import(/* webpackMode: "lazy" */  './hero/section.hero.agent'));
const SectionLogos = React.lazy(() => import(/* webpackMode: "lazy" */  './logos/section.logos'));
const SectionTestimonialSlider = React.lazy(() => import(/* webpackMode: "lazy" */  './testimonials/section.testimonial.slider'));
const SectionTestimonialGrid = React.lazy(() => import(/* webpackMode: "lazy" */  './testimonials/section.testimonial.grid'));
const SectionFloatingCta = React.lazy(() => import(/* webpackMode: "lazy" */  './cta/section.floating.cta'));
const SectionImageCta = React.lazy(() => import(/* webpackMode: "lazy" */  './cta/section.image.cta'));
const SectionProducts = React.lazy(() => import(/* webpackMode: "lazy" */  './products/section.products'));
const SectionProductsSimple = React.lazy(() => import(/* webpackMode: "lazy" */  './products/section.products.simple'));
const SectionHowItWorks = React.lazy(() => import(/* webpackMode: "lazy" */  './how.it.works/section.how.it.works'));
const SectionIconColumns = React.lazy(() => import(/* webpackMode: "lazy" */  './icon.columns/icon.columns'));
const SectionResources = React.lazy(() => import(/* webpackMode: "lazy" */  './resources/section.resources'));
const SectionResourceHub = React.lazy(() => import(/* webpackMode: "lazy" */  './resources/section.resource.hub'));
const SectionFileResources = React.lazy(() => import(/* webpackMode: "lazy" */  './resources/section.file.resources'));
const SectionOurStory = React.lazy(() => import(/* webpackMode: "lazy" */  './our.story/section.our.story'));
const SectionTeam = React.lazy(() => import(/* webpackMode: "lazy" */  './team/section.team'));
const SectionValues = React.lazy(() => import(/* webpackMode: "lazy" */  './values/section.values'));
const SectionImage = React.lazy(() => import(/* webpackMode: "lazy" */  './image/section.image'));
const SectionButtons = React.lazy(() => import(/* webpackMode: "lazy" */  './buttons/section.buttons'));
const SectionPress = React.lazy(() => import(/* webpackMode: "lazy" */  './press/section.press'));
const SectionStats = React.lazy(() => import(/* webpackMode: "lazy" */  './stats/section.stats'));
const SectionSideStats = React.lazy(() => import(/* webpackMode: "lazy" */  './stats/section.side.stats'));
const SectionStatsRows = React.lazy(() => import(/* webpackMode: "lazy" */  './stats/section.stats.rows'));
const SectionOpenings = React.lazy(() => import(/* webpackMode: "lazy" */  './openings/section.openings'));
const SectionVibe = React.lazy(() => import(/* webpackMode: "lazy" */  './vibe/section.vibe'));
const SectionSellingPoints = React.lazy(() => import(/* webpackMode: "lazy" */  './selling.points/section.selling.points'));
const SectionTwoColumnText = React.lazy(() => import(/* webpackMode: "lazy" */  './two.column.text/section.two.column.text'));
const SectionThreeColumnText = React.lazy(() => import(/* webpackMode: "lazy" */  './three.column.text/section.three.column.text'));
const SectionStoryCards = React.lazy(() => import(/* webpackMode: "lazy" */  './story.cards/section.story.cards'));
const SectionAccordion = React.lazy(() => import(/* webpackMode: "lazy" */  './accordion/section.accordion'));
const SectionTable = React.lazy(() => import(/* webpackMode: "lazy" */  './table/section.table'));
const SectionHeading = React.lazy(() => import(/* webpackMode: "lazy" */  './heading/section.heading'));
const SectionContent = React.lazy(() => import(/* webpackMode: "lazy" */  './content/section.content'));
const SectionSidebarContent = React.lazy(() => import(/* webpackMode: "lazy" */  './content/section.sidebar.content'));
const SectionHTML = React.lazy(() => import(/* webpackMode: "lazy" */  './html/section.html'));
const SectionBadges = React.lazy(() => import(/* webpackMode: "lazy" */  './badges/section.badges'));
const SectionOtherOffers = React.lazy(() => import(/* webpackMode: "lazy" */  './other.offers/section.other.offers'));
const SectionBlogPosts = React.lazy(() => import(/* webpackMode: "lazy" */  './posts/section.posts'));
const SectionArticles = React.lazy(() => import(/* webpackMode: "lazy" */  './posts/section.articles'));
const SectionCtaArticles = React.lazy(() => import(/* webpackMode: "lazy" */  './posts/section.cta.articles'));
const SectionHelpfulArticles = React.lazy(() => import(/* webpackMode: "lazy" */  './posts/section.helpful.articles'));
const SectionQuoteProposal = React.lazy(() => import(/* webpackMode: "lazy" */  './quote.proposal/section.quote.proposal'));




export const SectionsMap = {
    // 
    SectionHeroGeneric,
    SectionHeroProposal,

    /**
     * Lazy Components
     */
    SectionHeroAgent,

    // Logos
    SectionLogos,
    
    // Testimonials
    SectionTestimonialSlider,
    SectionTestimonialGrid,

    // CTAs
    SectionFloatingCta,
    SectionImageCta,
    
    // Products
    SectionProducts,
    SectionProductsSimple,
    
    // How It Works
    SectionHowItWorks,
    SectionIconColumns,

    // Resources
    SectionResources,
    SectionResourceHub,
    SectionFileResources,

    // Our Story
    SectionOurStory,

    // Team
    SectionTeam,

    // Values
    SectionValues,

    // Image
    SectionImage,

    // Buttons
    SectionButtons,

    // Press
    SectionPress,

    // Stats
    SectionStats,
    SectionStatsRows,
    SectionSideStats,

    // Openings
    SectionOpenings,

    // Vibe
    SectionVibe,

    // Two Column Text
    SectionTwoColumnText,
    SectionThreeColumnText,

    // Story Cards
    SectionStoryCards,

    // Accordion
    SectionAccordion,

    // Table
    SectionTable,

    // Heading
    SectionHeading,

    // Content
    SectionContent,
    SectionSidebarContent,
    SectionHTML,

    // Badges
    SectionBadges,

    // Selling Points
    SectionSellingPoints,

    // Offers
    SectionOtherOffers,

    
    // Articles | Posts
    SectionBlogPosts,
    SectionArticles,
    SectionCtaArticles,
    SectionHelpfulArticles,


    // Quote Proposal
    SectionQuoteProposal,

    
};